import { FC } from "react";
import { Pragraph } from "../Pragraph/Pragraph";

export const SecondSection: FC = () => {
  return (
    <li>
      <div>2. 利⽤⽬的</div>
      <Pragraph>
        当社は、お客様の個⼈情報を、お客様からのお問合せに対してご回答するため及び当 社 Web
        サイトの保守、管理ために、取得及び利⽤いたします。
      </Pragraph>
    </li>
  );
};
